/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import './m.css';
import ScrollAnimation from 'react-animate-on-scroll';
export default class Landing extends Component {

    render() {
        return (
            <div>
                <div className = "container-fluid">
                    <div className="row">
                        <div className="col-12 p-0">
                            <div className=" jumbotron-fluid min-vh-100 text-center m-0 d-flex flex-column justify-content-center jumbo">
                            <ScrollAnimation animateIn='fadeIn'>
                                <p className="name-styling font-weight-bolder ">SIDDHARTH  MISHRA</p>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn='fadeInUp'>
                                <p className="name-styling-subheading font-weight-bol">CREATIVE APP DEVELOPER & MINIMALIST LOVER</p>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
